import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Practices = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">📚 Practices</h1>
          <p className="text-muted-foreground">coding standards, design guidelines, workflows</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Practices Dashboard</CardTitle>
            <CardDescription>coding standards, design guidelines, workflows</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Practices content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Practices;